export namespace ConfigurationHelper {
  export function getBaseUrl() {
    const baseUrl = process.env.BASE_URL
    const port = process.env.PORT ?? 8070

    if (baseUrl) {
      if (baseUrl.startsWith('http')) {
        return baseUrl
      } else {
        return `https://${baseUrl}`
      }
    }

    return `http://localhost:${port}`
  }
}
